import { useEffect, useRef } from "react";
import { useLocation, useNavigationType } from "react-router-dom";
import { shouldScrollToTop, type RouteKey } from "@/lib/scrollToTop";

/**
 * Resets scroll on route change. The app uses `<BrowserRouter>` (not a data
 * router), so React Router's `<ScrollRestoration>` is unavailable. Layouts let
 * the document scroll, but each layout's `<main>` is `overflow-auto`, so it is
 * reset too in case it ever becomes the scroll container.
 */
export function ScrollToTop() {
  const location = useLocation();
  const navigationType = useNavigationType();
  const prev = useRef<RouteKey | null>(null);

  useEffect(() => {
    if (shouldScrollToTop(prev.current, location, navigationType)) {
      window.scrollTo(0, 0);
      document.querySelectorAll("main").forEach((el) => {
        el.scrollTop = 0;
      });
    }
    prev.current = location;
  }, [location, navigationType]);

  return null;
}
